import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { Content_SAL6030_R01 } from "./Content_SAL6030_R01";
import { DetailTable_SAL6030_R01 } from "./DetailTable_SAL6030_R01";
import { SAL6030_R01DetailDto, SAL6030_R01GroupDto, SAL6030_R01HeaderDto } from "./Dto_SAL6030_R01";
import SearchSection_SAL6030_R01 from "./SearchSection_SAL6030_R01";
import { useSAL6030_R01Store } from "./Store_SAL6030_R01";
import { TableGroup_SAL6030_R01 } from "./TableGroup_SAL6030_R01";
import { Table_SAL6030_R01 } from "./Table_SAL6030_R01";

const LR_RESIZER = {
	code: "SAL6030_R01-lr",
	type: "width" as const,
	storageKey: "SAL6030_R01-lr-split-width",
	min: 20,
	max: 80,
	default: 60,
} as const;

export const Container_SAL6030_R01 = () => {
	const { initData: SAL6030_R01initData } = useSAL6030_R01Store();

	const headerGridRef = useRef<AgGridReact<SAL6030_R01HeaderDto>>(null);
	const groupGridRef = useRef<AgGridReact<SAL6030_R01GroupDto>>(null);
	const detailGridRef = useRef<AgGridReact<SAL6030_R01DetailDto>>(null);

	const { fetchData, handleHeaderRowClick } = Content_SAL6030_R01({ headerGridRef });

	const lrContainerRef = useRef<HTMLDivElement>(null);
	const isLrResizing = useRef(false);
	const { splitValue: lrSplit, handleMouseDown: handleLrMouseDown } = useMouseContent({
		resizer: LR_RESIZER,
		isResizing: isLrResizing,
		containerRef: lrContainerRef,
	});

	const HEIGHT_RESIZER = {
		code: "SAL6030_R01-height",
		type: "height" as const,
		storageKey: "SAL6030_R01-height-split-height",
		min: 20,
		max: 80,
		default: 55,
	} as const;

	const wholeContainerRef = useRef<HTMLDivElement>(null);
	const bottomAreaRef = useRef<HTMLDivElement>(null);
	const isHeightResizing = useRef(false);

	const { splitValue: heightSplit, handleMouseDown: handleHeightMouseDown } = useMouseContent({
		resizer: HEIGHT_RESIZER,
		isResizing: isHeightResizing,
		containerRef: wholeContainerRef,
		infoRef: bottomAreaRef,
	});

	return (
		<div className="content-container flex flex-col h-full w-full">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={undefined}
				onDeleteClick={undefined}
				onSaveClick={undefined}
				onPrintClick={undefined}
				onExcelClick={undefined}
				onInitClick={SAL6030_R01initData}
			/>
			<SearchSection_SAL6030_R01 onAutoFetch={fetchData} />

			<div className="flex flex-1 flex-col min-h-0" ref={wholeContainerRef}>
				<div className="px-[12px] py-[5px] min-h-0" style={{ height: `${heightSplit}%` }}>
					<div className="flex gap-[4px] h-full w-full" ref={lrContainerRef}>
						<Table_SAL6030_R01
							headerGridRef={headerGridRef}
							onHeaderRowClick={handleHeaderRowClick}
							widthPct={lrSplit}
						/>
						<div
							className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300 flex-shrink-0"
							onMouseDown={(e) => handleLrMouseDown("LR", e.nativeEvent)}
							onDragStart={(e) => e.preventDefault()}
						/>
						<TableGroup_SAL6030_R01 groupGridRef={groupGridRef} widthPct={100 - lrSplit} />
					</div>
				</div>

				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e) => handleHeightMouseDown("UD", e.nativeEvent)}
					onDragStart={(e) => e.preventDefault()}
				/>

				<div
					className="px-[12px] py-[5px] min-h-0"
					style={{ height: `${100 - heightSplit}%` }}
					ref={bottomAreaRef}
				>
					<DetailTable_SAL6030_R01 detailGridRef={detailGridRef} />
				</div>
			</div>

			<Message />
		</div>
	);
};
